// src/PartnerCard.jsx

export default function PartnerCard({ partner }) {
  if (!partner) return null; // safety guard

  return (
    <div className="portfolio-card">
      <a
        href={partner.url || '#'}
        target="_blank"
        rel="noopener noreferrer"
        className="portfolio-image-wrap"
      >
        <img
          src={partner.image}
          alt={partner.title}
          className="portfolio-image"
        />
      </a>

      <h3 className="portfolio-title">{partner.title}</h3>

      <p className="portfolio-role">
        <strong>{partner.role}</strong>
      </p>

      <p className="portfolio-description">
        {partner.description}
      </p>
    </div>
  );
}
